import * as d3 from 'd3';
import { axisRadialInner } from "@/charts/radial-axis";


function solarChart() {
	var colorarray = ["#375A8B", "#829DC2", "#5374A1", "#214577", "#10315E", "#5B398F", "#9F85C6", "#7657A7", "#45237B", "#301161", "#369F4D", "#87D498", "#57B96D", "#1D8935", "#096C1F"];
	var originX = 250;
	var originY = 250;
	var legendRadius = 19;
	var circleRadius = 180;
	var satRadius = 6;
	var tickSize = 12;
	
	var tailLengthRange;
	var satRadiusRange = [2, 12]; //range for rendering scale based on data
	var satScaleVar;
	var tailScaleVar;
	var colorScaleVar;
	var timeScale = 'daily';
	var dateVar = 'time_period';
	var parseDate = d3.timeParse("%Y-%m-%dT%H:%M:%SZ");
	var hourlydatedisplay = d3.timeFormat("%I %p"),
			dailydatedisplay = d3.timeFormat("%d %b"),
			datedisplay = dailydatedisplay;
	
	
	function chart(selection) {
		if (timeScale == 'hourly') {
			datedisplay = hourlydatedisplay;
		}
		
		
		var svg = selection.append('svg')
				.attr("preserveAspectRatio", "xMinYMin meet")
				.attr("viewBox", "0 0 500 500")
				.classed("svg-content", true)
				.classed("solarSystemSVG", true);
		
		//create the tooltip. This is a div outside of the svg that I recreated because
		//I'm running multiple charts on the same page.
		var tooltip = d3.select('#tooltip');
		
		selection.each(function (data) {
			
			
			if (!data.length) {
				
				svg.remove();
				selection.append('div')
						.html("<h5 class = 'no-data-warning'>There is no data to display.</h5>")
						.style('text-align', 'center')
						.style('margin', '3em 1em')
				return;
			}
			
			data.forEach(function (d, i) {
				d.date = parseDate(d[dateVar]);
				if (!d.ata_minus_pta) d.ata_minus_pta = 0;
			});
			
			
			var volumeExtent = d3.extent(data, function (d) {
				return d.volume;
			});
			var ataExtent = d3.extent(data, function (d) {
				return d.ata_minus_pta;
			});
			
			var colorDomainArray = colorarray.map(function (d, i) {
				return i * (volumeExtent[1] - volumeExtent[0]) / colorarray.length + volumeExtent[0]
			});
			
			var satSize = d3
					.scalePow()
					.exponent(1)
					.domain(volumeExtent)
					.range([4, 35]);
			
			var lineLength = d3
					.scaleLinear()
					.domain([ataExtent[0], 0, ataExtent[1]])
					.range([-circleRadius * 0.25, 0, circleRadius * 0.25]);
			
			
			var rotationPoint = d3
					.scaleLinear()
					.domain([data[0].date, data[data.length - 1].date])
					.range([0, 360 - (360 / data.length)]);
			
			function calcRotation(h) {
				return "rotate(" + rotationPoint(h) + "," + originX + "," + originY + ")";
			}
			
			var colorscale = d3.scaleLinear()
					.domain(colorDomainArray)
					.range(colorarray)
					.interpolate(d3.interpolateHcl);
			
			
			//remove the first data point, it is overlapping.
			//this is kind of hacky.
			
			
			////////////////////////////////////////
			/// INNER CIRCLE -- BUILD LEGEND     ///
			/// WE USE THE RADIAL LEGEND LIBRARY ///
			////////////////////////////////////////
			
			
			var tickValuesArray = [];
			
			data.forEach(function (d, i) {
				
				if (data.length > 20) {
					if (!(i % 2)) {
						tickValuesArray.push(d.date);
					}
				} else {
					tickValuesArray.push(d.date);
				}
				
			});
			
			
			var radialLegend = svg
					.append("g")
					.attr("transform", "translate(" + originX + "," + originY + ")")
					.classed("axis", true)
					.call(
							axisRadialInner(
									rotationPoint.copy().range([0, (2 * Math.PI) - ((2 * Math.PI) / data.length)]),
									circleRadius - circleRadius * 0.44
							)
									.tickValues(tickValuesArray)
									.tickSize(tickSize)
									.tickFormat(datedisplay)
					);
			
			svg.select('path.domain').remove();
			
			//add text element to center of the circle
			var centertext = svg.append("g")
					.attr('class', 'center-text')
					.append('text')
					.attr("x", 250)
					.attr("y", 250)
					.attr('text-anchor', 'middle');
			
			
			var topgroup = svg.append("g");
			
			
			//The light outside circle that the 'satellites' orbit around.
			var satPath = topgroup
					.append("circle")
					.attr("cx", originX)
					.attr("cy", originY)
					.attr("r", circleRadius)
					.attr("fill", "none")
					.attr("stroke", "black")
					.attr("opacity", ".1");
			
			//define starting point and sattelite path.
			//important: even after rotation, each satellite maintains the same origin.
			//svg interperets all actions as being from that origin, then transforms them. (which is why each sat is a group.)
			var satOriginX = originX + circleRadius * Math.sin(0);
			var satOriginY = originY - circleRadius * Math.cos(0);
			
			var satellites = topgroup
					.selectAll("g")
					.data(data)
					.enter()
					.append("g")
					.on("mouseover", function (d, i) {
						
						var t = d3.select(this).select('circle');
						var thiscolor = t.attr('fill');
						var darkercolor = d3.hsl(thiscolor).darker();
						
						var tip = ''
						
						tip += '<tspan x="250" dy="-1em"  class = "datetimeshow" fill = "' + darkercolor + '">' + datedisplay(d.date) + '</tspan>';
						tip += '<tspan x="250" dy="1.5em" class = "volumeshow" fill = "' + thiscolor + '">' + d.volume + ' calls</tspan>';
						tip += '<tspan x="250" dy="1em" class = "ataptashow" fill = "' + thiscolor + '">' + d.ata_minus_pta + ' ATA-PTA</tspan>';
						
						centertext.html(tip);
						
						
						//get rid of tooltip after 3 seconds if no mouseout. (this is for mobile)
						setTimeout(function () {
							centertext.html();
						}, 3000);
					})
					.on("mouseout", function (d) {
						centertext.text('');
					});
			
			//set origin of the line. For no lines at beginning, set 'y2' to 0
			var ataLines = satellites
					.append("line")
					.attr("x1", satOriginX)
					.attr("y1", satOriginY)
					.attr("x2", satOriginX)
					.attr("y2", satOriginY - 60)
					.attr("stroke", "#10315E")
					.attr("stroke-linecap", "round")
					.attr("stroke-width", 2.2);
			
			var ataLinesFill = satellites
					.append("line")
					.attr("x1", satOriginX)
					.attr("y1", satOriginY)
					.attr("x2", satOriginX)
					.attr("y2", satOriginY - 60)
					.attr("stroke", "white")
					.attr("stroke-width", .9);
			
			var volumeSat = satellites
					.append("circle")
					.attr("cx", satOriginX)
					.attr("cy", satOriginY)
					.attr("r", 4)
					//.attr('r', function (d) { return satSize(d.volume) })
					.attr('fill', function (d) {
						return colorscale(d.volume)
					})
					.attr('fill', function (d) {
						return d3.rgb(colorscale(d.volume)).darker()
					})
					.attr("opacity", 0.4)
					.attr('fill-opacity', 0.7);
			
			///////////////////
			/// ANIMATIONS ///
			//////////////////
			
			// rotating the satellite
			var tween = function (d, i, a) {
				return d3.interpolateString(
						"rotate(0," + originX + "," + originY + ")",
						calcRotation(d.date)
				);
			};
			
			//move delay is the time of the first rotation.
			function roundRobin() {
				var moveDelay = 1000;
				satellites
						.transition()
						.duration(moveDelay)
						.attrTween("transform", tween);
				volumeSat
						.transition()
						.delay(moveDelay)
						.duration(800)
						.attr("r", function (d) {
							return satSize(d.volume);
						})
						.transition()
						.duration(500)
						.attr("opacity", 1);
				
				
				//these are the animation of the lines
				ataLinesFill
						.transition()
						.delay(moveDelay)
						.duration(800)
						.attr("y2", function (d) {
							var len = lineLength(d.ata_minus_pta);
							if (len >= 0) {
								return satOriginY - lineLength(d.ata_minus_pta) - satSize(d.volume);
							} else {
								return satOriginY - lineLength(d.ata_minus_pta) + satSize(d.volume);
							}
						})
						.transition()
						.duration(250)
						.attr("y1", function (d) {
							var l = lineLength(d.ata_minus_pta);
							if (l > 0) {
								return satOriginY - satSize(d.volume);
							} else {
								return satOriginY + satSize(d.volume);
							}
						});
				
				ataLines
						.transition()
						.delay(moveDelay)
						.duration(800)
						.attr("y2", function (d) {
							var len = lineLength(d.ata_minus_pta);
							if (len >= 0) {
								return satOriginY - lineLength(d.ata_minus_pta) - satSize(d.volume);
							} else {
								return satOriginY - lineLength(d.ata_minus_pta) + satSize(d.volume);
							}
						})
						.transition()
						.duration(250)
						.attr("y1", function (d) {
							var l = lineLength(d.ata_minus_pta);
							if (l > 0) {
								return satOriginY - satSize(d.volume);
							} else {
								return satOriginY + satSize(d.volume);
							}
						});
				
			}
			
			roundRobin();
			
		}) //end selection.each
		
	} //end chart
	
	////////////////////////////////////
	/// GETTER AND SETTER FUNCTIONS. ///
	////////////////////////////////////
	
	chart.colorarray = function (value) {
		if (!arguments.length) return colorarray;
		colorarray = value;
		return chart;
	};
	
	chart.originX = function (value) {
		if (!arguments.length) return originX;
		originX = value;
		return chart;
	};
	
	chart.originY = function (value) {
		if (!arguments.length) return originY;
		originY = value;
		return chart;
	};
	
	chart.legendRadius = function (value) {
		if (!arguments.length) return legendRadius;
		legendRadius = value;
		return chart;
	};
	
	chart.circleRadius = function (value) {
		if (!arguments.length) return circleRadius;
		circleRadius = value;
		return chart;
	};
	
	chart.satRadius = function (value) {
		if (!arguments.length) return satRadius;
		satRadius = value;
		return chart;
	};
	
	chart.tickSize = function (value) {
		if (!arguments.length) return tickSize;
		tickSize = value;
		return chart;
	};
	
	chart.dateVar = function (value) {
		if (!arguments.length) return dateVar;
		dateVar = value;
		return chart;
	};
	
	chart.timeScale = function (value) {
		if (!arguments.length) return timeScale;
		timeScale = value;
		return chart;
	};
	
	
	return chart;
	
	
} // end solar system chart


export default solarChart;
